<button
  id="{{aid}}"
  [attr.aid]="aid"
  type="{{type}}"
  [disabled]="disabled"
  [attr.disabled]="disabled ? 'disabled' : null"
  [attr.color]="color ? color : 'primary'"
  [attr.form]="form ? form : undefined"
  [ngClass]="{'icon-only': iconOnly, 'selected': selected}"
  raskHotkey="ctrl+s"
  container="body"
  ngbTooltip="{{tooltipText ? tooltipText : undefined}}" [openDelay]="300">
  @if (icon) {
    <i class="{{icon}}"></i>
  }
  <span #content>
    <ng-content></ng-content>
  </span>
  @if (!content.innerHTML.length) {
    <span>{{label}}</span>
  }
</button>